import { useContext, useEffect, useState } from 'react';
import { formatBirth, formatHandphone } from '../../utils/common';
import { TestingHqContext } from '../../context/TestingHqContext';
import { TestingContext } from '../../context/TestingContext';
import { TESTING_TEACHER_TYPE, TESTING_TEACHER_STATUS } from '../../constants/testing_teacher';
import { get_testing_place_list, get_testing_schedule_list, get_testing_teacher_list, get_testing_type, get_testing_list, upsert_testing_teacher, delete_testing_teacher } from '../../utils/restapi';
import './joins.css';
import ListBody from '../../components/list/ListBody';

const TestingTeacherJoins = () => {
  const { testingHqs } = useContext(TestingHqContext);
  const { testingObj, setTestingObj } = useContext(TestingContext);

  // 선택상자 목록들
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);
  const [testingPlaces, setTestingPlaces] = useState([]);
  const [testingSchedules, setTestingSchedules] = useState([]);

  const [testingPlaceObj, setTestingPlaceObj] = useState(null);
  const [testingScheduleObj, setTestingScheduleObj] = useState(null);

  // 목록
  const [items, setItems] = useState([]);
  const [originalItems, setOriginalItems] = useState([]); // 원본 데이터 저장
  const [changedItems, setChangedItems] = useState(new Set()); // 변경된 항목 인덱스 추적
  
  // 정렬 관련 상태
  const [sort, setSort] = useState('');
  const [desc, setDesc] = useState('');

  // 감독관 유형 상태 추가
  const [selectedTeacherType, setSelectedTeacherType] = useState('');

  // 시험유형 데이터 가져오기
  const getTestingTypes = async () => {
    console.log('getTestingTypes called');
    try {
      const response = await get_testing_type();
      console.log("getTestingTypes:", response);
      setTestingTypes(response);
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  // 시험에 대한 데이터 가져오기
  const getTesting = async (type) => {
    console.log(`getTesting called : ${type}`);
    try {
      const response = await get_testing_list({ type, page:1, rowsPerPage:1000, sort:'a_testing_id', desc:'desc' });
      console.log("getTesting:", response);
      setTestings(response.lists || response);
    } catch (error) {
      console.error("Error fetching testing:", error);
      setTestings([]);
    }
  };

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called`);

    if (testingHqs.length === 0) {
      setTestingPlaces([]);
      setTestingPlaceObj(null);
      return;
    }

    const json = {
      testing_id: testingObj?.testing_id || 0, // 수정: ?. 사용
      gcodes: testingHqs.map(hq => hq.code).join(','),
      page: 1,
      rowsPerPage: 1000,
      sort: 'a_gcode,a_code',
    };

    console.log("getTestingPlace params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      setTestingPlaces(response.lists);
      if(response.lists.length === 1) {
        setTestingPlaceObj(response.lists[0]);
      } else {
        setTestingPlaceObj(null);
      }
    } catch (error) {
      console.error("Error fetching place:", error);
      setTestingPlaces([]);
    }
  };

  // 시험에 대한 일정 데이터 가져오기
  const getTestingSchedules = async () => { 
    console.log(`getTestingSchedules called`);

    const json = {
      testing_id: testingObj?.testing_id || 0,
      page: 1,
      rowsPerPage: 1000,
    };

    console.log("getTestingSchedules params:", json);

    try {
      const response = await get_testing_schedule_list(json);
      console.log("getTestingSchedules:", response);
      setTestingSchedules(response.lists);
      if(response.lists.length === 1) {
        setTestingScheduleObj(response.lists[0]);
      } else {
        setTestingScheduleObj(null);
      }
    } catch (error) {
      console.error("Error fetching schedules:", error);
      setTestingSchedules([]);
    }
  };

  //고사실에 대한 데이터 가져오기
  const getItems = async () => {
    console.log(`getItems called`);

    // testingPlaceObj.data.teachers의 모든 값의 합 계산
    const teachersData = testingPlaceObj?.data?.teachers || {};
    const teachers = Object.values(teachersData).reduce((sum, value) => {
      return sum + (parseInt(value) || 0);
    }, 0);
    
    console.log('teachers data:', teachersData);
    console.log('total teachers:', teachers);

    const json = {
      testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
      testing_place_id: testingPlaceObj?.testing_place_id || 0,
      page: 1,
      rowsPerPage: 1000,
      sort: 'a.type, a.code*1',
      desc: 'asc'
    };

    if (selectedTeacherType) json.type = selectedTeacherType;
    console.log("getItems params:", json);

    try {
      const response = await get_testing_teacher_list(json);
      console.log("getItems:", response);
      console.log(`response.lists.length: ${response.lists.length}, total teachers: ${teachers}`);

      // 감독관 수에 맞게 항목 추가 또는 제거
      let adjustedLists = response.lists || [];
      
      console.log(`selectedTeacherType : ${selectedTeacherType}`);
      // 전체 감독관 수가 다르면
      const isMasterShow = !selectedTeacherType || parseInt(selectedTeacherType) === TESTING_TEACHER_TYPE.field.master;
      const isMainShow = !selectedTeacherType || parseInt(selectedTeacherType) === TESTING_TEACHER_TYPE.field.main;
      const isSubShow = !selectedTeacherType || parseInt(selectedTeacherType) === TESTING_TEACHER_TYPE.field.sub;
      const isInfoShow = !selectedTeacherType || parseInt(selectedTeacherType) === TESTING_TEACHER_TYPE.field.info;
      const isReserveShow = !selectedTeacherType || parseInt(selectedTeacherType) === TESTING_TEACHER_TYPE.field.reserve;
      console.log(`isMasterShow: ${isMasterShow}, isMainShow: ${isMainShow}, isSubShow: ${isSubShow}, isInfoShow: ${isInfoShow}, isReserveShow: ${isReserveShow}`);

      // 총감독관 수 맞추기
      let master_teachers = adjustedLists.filter(item => item.type === TESTING_TEACHER_TYPE.field.master).length;
      console.log(`master_teachers: ${master_teachers}, required: ${teachersData.master}`);
      if (isMasterShow && master_teachers < teachersData.master) {
        for (let i = 0; i < teachersData.master - master_teachers; i++) {
          adjustedLists.push({
            testing_teacher_id: 0,
            testing_place_id: testingPlaceObj?.testing_place_id || 0,
            testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
            person_id: 0,
            room_no: '',
            idx: adjustedLists.length + i + 1,
            type: TESTING_TEACHER_TYPE.field.master,
            code: `#${TESTING_TEACHER_TYPE.field.master}#${adjustedLists.length + i + 1}`,
            name: `총감독관${teachersData.master > 1 ? ` ${adjustedLists.length + i + 1}` : ''}`,
            status: TESTING_TEACHER_STATUS.field.join,
            personObj: {
              name: '',
              birth: '',
              handphone: '',
            }
          });
        }
      }

      // 시험감독관(정) 수 맞추기
      let main_teachers = adjustedLists.filter(item => item.type === TESTING_TEACHER_TYPE.field.main).length;
      if (isMainShow && main_teachers < teachersData.main) {
        for (let i = 0; i < teachersData.main; i++) {
          const idx = i + 1;
          if (adjustedLists.findIndex(item => item.type === TESTING_TEACHER_TYPE.field.main && item.idx === idx) === -1) {
            adjustedLists.push({
              testing_teacher_id: 0,
              testing_place_id: testingPlaceObj?.testing_place_id || 0,
              testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
              person_id: 0,
              room_no: `${idx}고사실`,
              idx: idx,
              type: TESTING_TEACHER_TYPE.field.main,
              code: `#${TESTING_TEACHER_TYPE.field.main}#${adjustedLists.length + i + 1}`,
              name: `${idx}고사실 ${TESTING_TEACHER_TYPE.name[TESTING_TEACHER_TYPE.field.main]}`,
              status: TESTING_TEACHER_STATUS.field.join,
              personObj: {
                name: '',
                birth: '',
                handphone: '',
              }
            });
          }
        }
      }

      // 시험감독관(부) 수 맞추기
      let sub_teachers = adjustedLists.filter(item => item.type === TESTING_TEACHER_TYPE.field.sub).length;
      if (isSubShow && sub_teachers < teachersData.sub) {
        for (let i = 0; i < teachersData.sub; i++) {
          const idx = i + 1;
          if (adjustedLists.findIndex(item => item.type === TESTING_TEACHER_TYPE.field.sub && item.idx === idx) === -1) {
            adjustedLists.push({
              testing_teacher_id: 0,
              testing_place_id: testingPlaceObj?.testing_place_id || 0,
              testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
              person_id: 0,
              room_no: `${idx}고사실`,
              idx: idx,
              type: TESTING_TEACHER_TYPE.field.sub,
              code: `#${TESTING_TEACHER_TYPE.field.sub}#${adjustedLists.length + i + 1}`,
              name: `${idx}고사실 ${TESTING_TEACHER_TYPE.name[TESTING_TEACHER_TYPE.field.sub]}`,
              status: TESTING_TEACHER_STATUS.field.join,
              personObj: {
                name: '',
                birth: '',
                handphone: '',
              }
            });
          }
        }
      }

      // 통제위원 수 맞추기
      let info_teachers = adjustedLists.filter(item => item.type === TESTING_TEACHER_TYPE.field.info).length;
      if (isInfoShow && info_teachers < teachersData.info) {
        for (let i = 0; i < teachersData.info; i++) {
          const idx = i + 1;
          if (adjustedLists.findIndex(item => item.type === TESTING_TEACHER_TYPE.field.info && item.idx === idx) === -1) {
            adjustedLists.push({
              testing_teacher_id: 0,
              testing_place_id: testingPlaceObj?.testing_place_id || 0,
              testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
              person_id: 0,
              room_no: ``,
              idx: idx,
              type: TESTING_TEACHER_TYPE.field.info,
              code: `#${TESTING_TEACHER_TYPE.field.info}#${adjustedLists.length + i + 1}`,
              name: `${idx}고사실 ${TESTING_TEACHER_TYPE.name[TESTING_TEACHER_TYPE.field.info]}`,
              status: TESTING_TEACHER_STATUS.field.join,
              personObj: {
                name: '',
                birth: '',
                handphone: '',
              }
            });
          }
        }
      }

      // 관리위원
      let reserve_teachers = adjustedLists.filter(item => item.type === TESTING_TEACHER_TYPE.field.reserve).length;
      if (isReserveShow && reserve_teachers < teachersData.reserve) {
        for (let i = 0; i < teachersData.reserve; i++) {
          const idx = i + 1;
          if (adjustedLists.findIndex(item => item.type === TESTING_TEACHER_TYPE.field.reserve && item.idx === idx) === -1) {
            adjustedLists.push({
              testing_teacher_id: 0,
              testing_place_id: testingPlaceObj?.testing_place_id || 0,
              testing_schedule_id: testingScheduleObj?.testing_schedule_id || 0,
              person_id: 0,
              room_no: ``,
              idx: idx,
              type: TESTING_TEACHER_TYPE.field.reserve,
              code: `#${TESTING_TEACHER_TYPE.field.reserve}#${adjustedLists.length + i + 1}`,
              name: `${idx}고사실 ${TESTING_TEACHER_TYPE.name[TESTING_TEACHER_TYPE.field.reserve]}`,
              status: TESTING_TEACHER_STATUS.field.join,
              personObj: {
                name: '',
                birth: '',
                handphone: '',
              }
            });
          }
        }
      }
      console.log(adjustedLists);
      setItems(adjustedLists);
    } catch (error) {
      console.error("Error fetching schedules:", error);
      setItems([]);
    }
  };

  // 시험유형 선택 핸들러
  const handleTestingTypeChange = (e) => {
    console.log('handleTestingTypeChange called');
    const selectedValue = e.target.value;
    setTestingObj({ type: selectedValue });
  };

  // 시험 선택 핸들러
  const handleTestingChange = (e) => {
    console.log('handleTestingChange called');
    const selectedValue = e.target.value;
    const selectedTesting = testings.find(obj => obj.testing_id === parseInt(selectedValue));
    setTestingObj(selectedTesting);
  };

  // 일정 선택 핸들러
  const handleTestingScheduleChange = (e) => {
    console.log('handleTestingScheduleChange called');
    const selectedValue = e.target.value;
    const selectedSchedule = testingSchedules.find(obj => obj.testing_schedule_id === parseInt(selectedValue));
    setTestingScheduleObj(selectedSchedule);
  };

  // 장소 선택 핸들러
  const handleTestingPlaceChange = (e) => {
    console.log('handleTestingPlaceChange called');
    const selectedValue = e.target.value;
    const selectedPlace = testingPlaces.find(obj => obj.testing_place_id === parseInt(selectedValue));
    setTestingPlaceObj(selectedPlace);
  };

  // 감독관 선택 핸들러
  const handleTeacherTypeChange = (e) => {
    console.log('handleTeacherTypeChange called');
    const selectedValue = e.target.value;
    setSelectedTeacherType(selectedValue);
  };

  // 고사장 정보 업데이트
  const handleSubmit = async () => {
    console.log('handleSubmit called');
    console.log('변경된 항목들:', Array.from(changedItems));
    
    if (changedItems.size === 0) {
      alert('변경된 항목이 없습니다.');
      return;
    }

    const updatePromises = [];
    
    // 변경된 항목들만 순회
    for (const index of changedItems) {
      const item = items[index];
      
      // personObj의 필수 값들이 모두 비어있는지 확인
      const isEmpty = !item.personObj?.name?.trim() && 
                     !item.personObj?.birth?.trim() && 
                     !item.personObj?.handphone?.trim();
      
      if (isEmpty && item.testing_teacher_id > 0) {
        // 모든 값이 비어있고 기존 데이터가 있으면 삭제
        console.log(`인덱스 ${index} 삭제 처리:`, item.testing_teacher_id);
        
        updatePromises.push(
          delete_testing_teacher(item.testing_teacher_id)
            .then(result => {
              console.log(`인덱스 ${index} 삭제 성공:`, result);
              return { index, success: true, result, action: 'delete' };
            })
            .catch(error => {
              console.error(`인덱스 ${index} 삭제 실패:`, error);
              return { index, success: false, error, action: 'delete' };
            })
        );
      } else if (!isEmpty) {
        // 값이 있으면 업데이트
        const updateData = {
          testing_teacher_id: item.testing_teacher_id || 0,
          testing_place_id: item.testing_place_id,
          testing_schedule_id: item.testing_schedule_id,
          type: item.type,
          code: `#${item.type}#${item.idx}`,
          name: item.name,
          room_no: item.room_no,
          status: item.status,
          personObj: item.personObj
        };
        
        console.log(`인덱스 ${index} 업데이트:`, updateData);
        
        updatePromises.push(
          upsert_testing_teacher(updateData)
            .then(result => {
              console.log(`인덱스 ${index} 업데이트 성공:`, result);
              return { index, success: true, result, action: 'upsert' };
            })
            .catch(error => {
              console.error(`인덱스 ${index} 업데이트 실패:`, error);
              return { index, success: false, error, action: 'upsert' };
            })
        );
      } else {
        // 값이 비어있고 새로운 데이터면 아무것도 하지 않음
        console.log(`인덱스 ${index} 처리 생략 (빈 값, 새 데이터)`);
      }
    }

    if (updatePromises.length === 0) {
      alert('처리할 항목이 없습니다.');
      return;
    }

    try {
      // 모든 업데이트를 병렬로 실행
      const results = await Promise.all(updatePromises);
      
      // 결과 확인
      const successCount = results.filter(r => r.success).length;
      const failCount = results.filter(r => !r.success).length;
      const deleteCount = results.filter(r => r.success && r.action === 'delete').length;
      const upsertCount = results.filter(r => r.success && r.action === 'upsert').length;
      
      if (failCount === 0) {
        let message = '';
        if (upsertCount > 0) message += `${upsertCount}개 항목 저장`;
        if (deleteCount > 0) {
          if (message) message += ', ';
          message += `${deleteCount}개 항목 삭제`;
        }
        message += '가 성공적으로 완료되었습니다.';
        
        alert(message);
        
        // 원본 데이터를 현재 데이터로 업데이트
        setOriginalItems(JSON.parse(JSON.stringify(items)));
        setChangedItems(new Set()); // 변경 상태 초기화
        
        // 데이터 다시 불러오기
        getItems();
      } else {
        alert(`${successCount}개 항목 처리 성공, ${failCount}개 항목 처리 실패`);
      }
      
    } catch (error) {
      console.error('저장 중 오류 발생:', error);
      alert('저장 중 오류가 발생했습니다.');
    }
  };

  // 구분 표시
  const displayType = (item) => {
    const typeValue = item.type;
    if (TESTING_TEACHER_TYPE.value.includes(typeValue)) {
      return (
        <span className="type">
          {TESTING_TEACHER_TYPE.name[typeValue]}
        </span>
      );
    }
    return '';
  }

  // 상태 표시
  const displayStatus = (item) => {
    const statusValue = parseInt(item.status, 10);
    
    // 방어 코드 추가
    if (!TESTING_TEACHER_STATUS || !TESTING_TEACHER_STATUS.value || !Array.isArray(TESTING_TEACHER_STATUS.value)) {
      console.error('TESTING_TEACHER_STATUS가 올바르게 로드되지 않았습니다:', TESTING_TEACHER_STATUS);
      return '';
    }
    
    if (TESTING_TEACHER_STATUS.value.includes(statusValue)) {
      const className = TESTING_TEACHER_STATUS.unused.includes(statusValue) ? 'unused' : TESTING_TEACHER_STATUS.used.includes(statusValue) ? 'used' : '';

      console.log('Displaying status for value:', statusValue, 'with className:', className);
      return (
        <span className={`status ${className}`}>
          {TESTING_TEACHER_STATUS.name[statusValue]} {/* TESTING_TEACHER_STATUS가 아닌 TESTING_TEACHER_STATUS 사용 */}
        </span>
      );
    }
    return '';
  };

  // 공통 함수 정의
  const handleFieldChange = (index, field, newValue) => {
    console.log(`${field} onChange:`, newValue);

    if (field === 'birth') {
      newValue = formatBirth(newValue);
      console.log('Formatted birth:', newValue);
    } else if (field === 'handphone') {
      newValue = formatHandphone(newValue);
      console.log('Formatted handphone:', newValue);
    }
    
    // 1. UI 업데이트
    setItems(prev => {
      const newItems = prev.map((row, i) =>
        i === index ? {
          ...row,
          personObj: {
            ...row.personObj,
            [field]: newValue
          }
        } : row
      );
      console.log('setItems 완료:', newItems[index]);
      return newItems;
    });

    // 2. 변경된 항목으로 표시 (중복 체크)
    setChangedItems(prev => {
      if (!prev.has(index)) {
        console.log(`항목 ${index} 변경 목록에 추가`);
        return new Set([...prev, index]);
      } else {
        console.log(`항목 ${index}은 이미 변경 목록에 있음`);
        return prev;
      }
    });
  };

  const headers = [
    { 
      name: 'NO.', 
      value: '',
      renderCell: (item, index) => index + 1
    },
    { 
      name: '감독관구분', 
      value: 'a_type',
      renderCell: (item) => displayType(item)
    },
    { 
      name: '고사실명', 
      value: 'a_room_no',
      renderCell: (item, index) => item.room_no
    },
    { 
      name: '감독관 성명', 
      value: '',
      renderCell: (item, index) => <input type="text" value={item.personObj?.name || ''} onChange={e => handleFieldChange(index, 'name', e.target.value)} />
    },
    { 
      name: '감독관 생년월일', 
      value: '',
      renderCell: (item, index) => <input type="text" value={item.personObj?.birth || ''} onChange={e => handleFieldChange(index, 'birth', e.target.value)} />
    },
    {
      name: '감독관 휴대폰번호',
      value: '',
      renderCell: (item, index) => <input type="text" value={item.personObj?.handphone || ''} onChange={e => handleFieldChange(index, 'handphone', e.target.value)} />
    },
    { 
      name: '상태',
      value: '',
      renderCell: (item) => displayStatus(item)
    }
  ];

  useEffect(() => {
    getTestingTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (testingHqs.length) getTestingPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs]);

  useEffect(() => {
    if (testingObj?.type) {
      getTesting(testingObj.type);
      getTestingSchedules();
      getTestingPlaces();
    } else {
      setTestings([]);
      setTestingPlaces([]);
      setTestingSchedules([]);
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.type]);

  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      getTestingSchedules();
      getTestingPlaces();
    } else {
      setTestingPlaces([]);
      setTestingSchedules([]);
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  useEffect(() => {
    //console.log('testing_schedule_id : ', testingScheduleObj?.testing_schedule_id, ' testing_place_id : ', testingPlaceObj?.testing_place_id);
    if (testingScheduleObj && testingScheduleObj.testing_schedule_id && testingPlaceObj && testingPlaceObj.testing_place_id) {
      getItems();
    } else {
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingScheduleObj?.testing_schedule_id, testingPlaceObj?.testing_place_id]);

  useEffect(() => {
    console.log('selectedTeacherType changed : ', selectedTeacherType);
    if (testingScheduleObj && testingScheduleObj.testing_schedule_id && testingPlaceObj && testingPlaceObj.testing_place_id) {
      getItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTeacherType]);

  return (
    <div id="testing_teacher_joins">
      <div className="head">
        <h1>회차별 감독관 배정</h1>
        <span><button onClick={handleSubmit}>저장하기</button></span>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>구분</label>
            <span>
              <select value={testingObj?.type || 0} onChange={handleTestingTypeChange}>
                <option value="">▒ 구분 ▒</option>
                {testingTypes.map((obj, index) => (
                  <option key={index} value={obj.code}>
                    {obj.nickname || obj.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>시험</label>
            <span>
              <select value={testingObj?.testing_id || 0} onChange={handleTestingChange}>
                <option value="">▒ 시험 ▒</option>
                {testings.map((obj, index) => (
                  <option key={index} value={obj.testing_id}>
                    {obj.title}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>일정</label>
            <span>
              <select value={testingScheduleObj?.testing_schedule_id || 0} onChange={handleTestingScheduleChange}>
                <option value="">▒ 일정 ▒</option>
                {testingSchedules.map((obj, index) => (
                  <option key={index} value={obj.testing_schedule_id}>
                    {obj.testStartDate} ~ {obj.testStopDate}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>고사장</label>
            <span>
              <select value={testingPlaceObj?.testing_place_id || 0} onChange={handleTestingPlaceChange}>
                <option value="">▒ 고사장 ▒</option>
                {testingPlaces.map((obj, index) => (
                  <option key={index} value={obj.testing_place_id}>
                    {obj.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>감독관</label>
            <span>
              <select value={selectedTeacherType} onChange={handleTeacherTypeChange}>
                <option value="">▒ 감독관 ▒</option>
                {TESTING_TEACHER_TYPE.value.map((typeValue, index) => (
                  <option key={index} value={typeValue}>
                    {TESTING_TEACHER_TYPE.name[typeValue]}
                  </option>
                ))}
              </select>
            </span>
          </li>
        </ul>
        <ListBody
          headers={headers}
          items={items}
          sort={sort}
          desc={desc}
          setSort={setSort}
          setDesc={setDesc}
          className="place_table"
        />
      </div>
      <div className="foot">
        <button onClick={handleSubmit}>저장하기</button>
      </div>
    </div>
  );
};

export default TestingTeacherJoins;